import { IContextMenuService } from "../IContextMenuService";

import { ContextMenuState } from "../../../model/contextmenu/ContextMenuState";

import { ContextMenuItem } from "../../../model/contextmenu/ContextMenuItem";

import { ContextMenuServiceResponse } from "../../../model/contextmenu/ContextMenuServiceResponse";

export abstract class ContextMenuService<I, T extends ContextMenuItem<I>>
  implements IContextMenuService<I, T>
{
  public abstract getMenuItems(
    selectedIds: Array<string>,
    menuState: ContextMenuState,
  ): Promise<ContextMenuServiceResponse<I, ContextMenuItem<I>>>;
}
